import React from 'react';
import { BarChart, Bar, XAxis, YAxis, LabelList } from 'recharts';


const EquityBarChart = ({equityData}) => {


    const CustomAxisTick = ({ x, y, payload, fontSize }) => {
        const padding_left = 0;
        const padding_bottom = 0;
      
    
        return (
          <text
            x={x - padding_left}
            y={y + fontSize + padding_bottom}
            fontSize={fontSize}
            textAnchor="middle"
            fill="#666"
            transform={`rotate(0, ${x - padding_left}, ${y + fontSize + padding_bottom})`}
          >
            {payload.value}
          </text>
        );
      };
    
      const labels = equityData.map(data => data.label);
    
      const phillyEquity = [
        { label: 'White', value: 33.72 },
        { label: 'Black', value: 42.01 },
        { label: 'Asian', value: 6.66 },
        { label: 'Hisp/Lat', value: 13.71 },
        { label: 'Others', value: 5.68 },
      ];
    
      const currentEquity = [
        { label: 'White', value: 45.92 },
        { label: 'Black', value: 33.21 },
        { label: 'Asian', value: 9.16 },
        { label: 'Hisp/Lat', value: 8.01 },
        { label: 'Others', value: 6.89 },
      ];
    
    
      const CustomBarShape = (props) => {
        const { x, y, width, stroke, strokeWidth } = props;
      
        // Adjust the x position to overlap with other bars
        return (
          <line
            x1={x - width -5}
            y1={y}
            x2={x +5}
            y2={y}
            stroke={stroke}
            strokeWidth={strokeWidth}
          />
        );
      };
    
      const CustomBarShape2 = (props) => {
        const { x, y, width, height, fill } = props;
      
        // Adjust the x position to overlap with other bars
        return (
          <rect
            x={x}
            y={y}
            width={width}
            height={height}
            fill={fill}
          />
        );
      };
    
      const CustomBarShape3 = (props) => {
        const { x, y, width, height, fill } = props;
      
        // Adjust the x position to overlap with other bars
        return (
          <rect
            x={x + width}
            y={y}
            width={width}
            height={height}
            fill={fill}
          />
        );
      };
      
      const CustomLabel = (props) => {
        const { x, y, value } = props;
        
        return (
          <text x={x+11} y={y-6} fill="#0078A8" fontSize={10} textAnchor="middle">
            {`${value}%`}
          </text>
        );
      };

  return (
    <BarChart
      width={280}
      height={220}
      data={equityData}
      margin={{ top: 20, right: -280, left: -60, bottom: 0 }}
    >
      <XAxis dataKey="label" tick={<CustomAxisTick fontSize={12} />} interval={0} axisLine={false} />
      <YAxis domain={[5, 48]} tick={false} axisLine={false} />
      <Bar dataKey="value" data={currentEquity} fill="#D3D6D6" barSize={20} shape={<CustomBarShape3 />} />
      <Bar dataKey="percentage" fill="#0078A8" barSize={20} shape={<CustomBarShape2 />}>
        <LabelList dataKey="percentage" content={<CustomLabel />} />
      </Bar>
      <Bar dataKey="value" data={phillyEquity} fill="transparent" barSize={20} shape={<CustomBarShape stroke="rgb(252, 123, 123)" strokeWidth={2.5} />} />
      <g>
        <line
          x1={10}
          y1={190}
          x2={270}
          y2={190}
          stroke="grey"
          strokeWidth={0.5}
        />
      </g>
    </BarChart>
  );
};


export default EquityBarChart;